import styled from 'styled-components';
import {
  StyledChannelListHeader,
  StyledChannelListWrapper
} from '../ChatList/Styled';
import {
  StyledMessageListHeader,
  StyledSidePanelHeader,
  StyledSidePanelOpenButton
} from '../ChatMessages/Styled';
import { StyledHeading } from '../../chat/Heading/Styled';
import { flexVerticalMiddle } from '../../../utils/style';
import { StyledChatBubble } from '../../chat/ChatBubble/Styled';

export const StyledLiffContent = styled.div`
  position: fixed;
  top: 2.75rem;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;

  // 問い合わせ一覧のスタイルを上書きする
  ${StyledChannelListWrapper} {
    border-right: none;
    background: none;
  }

  ${StyledChannelListHeader} {
    flex: 0 0 auto;
    font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
    line-height: ${(props) => props.theme.fontSizes.h6.lineHeight};
    padding: 1rem;
    justify-content: flex-start;
  }

  // メッセージ一覧のスタイルを上書きする
  ${StyledMessageListHeader} {
    flex: 0 0 auto;
    color: ${(props) => props.theme.colors.greys.grey80};
    padding: 1rem;
    justify-content: flex-start;
    background: none;
    border: none;

    ${StyledHeading} {
      font-size: ${(props) => props.theme.fontSizes.text.fontSize};
      line-height: ${(props) => props.theme.fontSizes.text.lineHeight};
      ${flexVerticalMiddle}

      .icon {
        flex-shrink: 0;
        margin-right: 1.25rem;
      }
    }
  }

  ${StyledSidePanelOpenButton} {
    top: 2rem;
  }

  ${StyledSidePanelHeader} {
    flex: 0 0 auto;
    padding: 1rem;
  }

  ${StyledChatBubble} {
    .ch-footer,
    .ch-sender-name {
      display: none;
    }
  }
`;
